// PREF-UC-2: темы оформления и цветовые режимы выбираются независимо.
// Новая тема — новая строка здесь и файл apps/web/src/styles/themes/<id>.css.
export enum ThemeName {
  Frog = 'frog',
  Journal = 'journal',
  Craft = 'craft',
  Kitchen = 'kitchen',
}

export enum ColorMode {
  Light = 'light',
  Dark = 'dark',
  System = 'system',
}

export const DEFAULT_THEME = ThemeName.Frog;
export const DEFAULT_COLOR_MODE = ColorMode.System;

export interface ThemeDescriptor {
  id: ThemeName;
  /** Пастельная (лёгкая) или контрастная палитра. */
  pastel: boolean;
  /** Цвета-образцы для переключателя: фон, акцент, второй акцент. */
  swatches: readonly [string, string, string];
}

export const THEMES: readonly ThemeDescriptor[] = [
  { id: ThemeName.Frog, pastel: false, swatches: ['#141213', '#FF2E7E', '#E2622F'] },
  { id: ThemeName.Journal, pastel: false, swatches: ['#FFFFFF', '#111111', '#D7261E'] },
  { id: ThemeName.Craft, pastel: true, swatches: ['#F7F1E6', '#9DB58A', '#F2B89B'] },
  { id: ThemeName.Kitchen, pastel: true, swatches: ['#F6F8FA', '#8FD3C1', '#B9B4EC'] },
];

export const COLOR_MODES: readonly ColorMode[] = [ColorMode.Light, ColorMode.Dark, ColorMode.System];

export function isThemeName(value: unknown): value is ThemeName {
  return THEMES.some((theme) => theme.id === value);
}

export function isColorMode(value: unknown): value is ColorMode {
  return COLOR_MODES.includes(value as ColorMode);
}
